import Skeleton from "react-loading-skeleton";

export const DefaultTicket = () => {
  return (
    <div className="row">
      <div className="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <div className="ps-block--checkout-order">
          <div className="ps-block__content text_Center___develop">
            <span>
              <Skeleton width={100} height={100} />
            </span>
            <figure>
              <h2>
                <Skeleton width={"100%"} height={50} />
              </h2>
            </figure>
            <strong className="develop___text">
              <Skeleton width={"100%"} height={50} />
            </strong>
            <h3>
              <Skeleton width={"100%"} height={50} />
            </h3>
            <strong className="develop___text develop___salto_text">
              <Skeleton width={"100%"} height={50} />
            </strong>
            <h3>
              <Skeleton width={"100%"} height={50} />
            </h3>
            <strong className="develop___text develop___salto_text">
              <Skeleton width={"100%"} height={50} />
            </strong>
            <h3 className="develop___salto_text">
              <Skeleton width={"100%"} height={50} />
            </h3>
            <strong className="develop___text develop___salto_text">
              <Skeleton width={"100%"} height={50} />
            </strong>
            <h3>
              <Skeleton width={"100%"} height={50} />
            </h3>
            <strong className="develop___text develop___salto_text">
              <Skeleton width={"100%"} height={50} />
              <h3>
                <Skeleton width={"100%"} height={50} />
              </h3>
            </strong>
            <Skeleton width={"100%"} height={80} />
            <strong className="develop___text develop___salto_Codbarra">
              <Skeleton width={"100%"} height={50} />
            </strong>
            <div className="row">
              <div className="col-md-12 col-12">
                <Skeleton width={"100%"} height={100} />
              </div>
            </div>
            <strong className="develop___text">
              <Skeleton width={"100%"} height={50} />
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};
